import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  Router
} from '@angular/router';
import { ProfileService } from '../shared/services/profile.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/env';
import { of } from 'rxjs';

import { timeout, map, catchError } from 'rxjs/operators';

declare const InstallTrigger: any;

@Injectable()
export class OnlineGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private profileService: ProfileService, private http: HttpClient) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkOnline();
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
  checkOnline(): Observable<boolean> {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox) {
      return this.hostReachable();
    } else if (!isFirefox && navigator.onLine) {
      return of(true);
    } else {
      this.router.navigate(['/offline']);
      return of(false);
    }
  }

  /*
        Do an empty request to the API
     */
  hostReachable(): Observable<boolean> {
    // just check if request to BE is possible
    return this.http.get(environment.ABSOLUTE_PATH + '/api/ping', null).pipe(
      timeout(2000),
      map(
        res => {
          return true;
        },
        err => {
          this.router.navigate(['/offline']);
          return false;
        }
      ),
      catchError(err => {
        this.router.navigate(['/offline']);
        return of(false);
      })
    );
  }
}
